export class ClassFullError extends Error {

  code?: string = 'reservation/class-full';
}
